// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EUProgramme  {
    _originalTypeClassName = "Loom.BO.EUProgramme";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EUProgramme.translate = translateService;
}
this.UnitCostRates = [];
this.CountryCoefficients = [];
this.Name = null;
this.MaxAllowedAnnualDays = null;
this.MaxAllowedAnnualHours = null;
this.HoursForUnitCostCalculation = null;
this.DaysForUnitCostCalculation = null;
this.CFSThreshold = null;
this._key = this.Name = ""; 
}

static translate: TranslateService;
_key: any;
private _Name:any;
get Name(): any {
    return this._Name;
  }
set Name(value: any) {
    this._Name = value;
    this._key = value;
  }
MaxAllowedAnnualDays:any;
MaxAllowedAnnualHours:any;
HoursForUnitCostCalculation:any;
DaysForUnitCostCalculation:any;
CFSThreshold:any;
UnitCostRates:any;
CountryCoefficients:any;
static setUnitCostRates = ($this, items) => {
                if (items == null) items = [];
                if ($this.UnitCostRates == null) $this.UnitCostRates = [];

                const copyItems = Common.cloneObject(items);

                while ($this.UnitCostRates.length > 0) {
                    Domain.EUProgramme.removeUnitCostRates($this, $this.UnitCostRates[0]);
                }

                Domain.EUProgramme.addManyUnitCostRates($this, copyItems);
            }
static addManyUnitCostRates = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EUProgramme.addUnitCostRates($this, items[i]);
                }
            }
static addUnitCostRates = ($this, item) => {
                if ($this.UnitCostRates == null) $this.UnitCostRates = [];
                if (item == null || $this.UnitCostRates.indexOf(item) > -1) return;
                $this.UnitCostRates.push(item);
if (item.EUProgramme != $this) {
Domain.UnitCostRate.setEUProgramme(item, $this);
}
}
static addRangeUnitCostRates = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EUProgramme.addUnitCostRates($this, item));
            }
static removeUnitCostRates = ($this, item) => {
                if ($this == null || $this.UnitCostRates == null || $this.UnitCostRates.indexOf(item) === -1) return;
                var _index = $this.UnitCostRates.indexOf(item);
                $this.UnitCostRates.splice(_index, 1);
item.EUProgramme = null;
}
static clearUnitCostRates = ($this) => { $this.UnitCostRates = null; }
static setCountryCoefficients = ($this, items) => {
                if (items == null) items = [];
                if ($this.CountryCoefficients == null) $this.CountryCoefficients = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CountryCoefficients.length > 0) {
                    Domain.EUProgramme.removeCountryCoefficients($this, $this.CountryCoefficients[0]);
                }

                Domain.EUProgramme.addManyCountryCoefficients($this, copyItems);
            }
static addManyCountryCoefficients = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EUProgramme.addCountryCoefficients($this, items[i]);
                }
            }
static addCountryCoefficients = ($this, item) => {
                if ($this.CountryCoefficients == null) $this.CountryCoefficients = [];
                if (item == null || $this.CountryCoefficients.indexOf(item) > -1) return;
                $this.CountryCoefficients.push(item);
if (item.EUProgramme != $this) {
Domain.CorrectionCoefficient.setEUProgramme(item, $this);
}
}
static addRangeCountryCoefficients = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EUProgramme.addCountryCoefficients($this, item));
            }
static removeCountryCoefficients = ($this, item) => {
                if ($this == null || $this.CountryCoefficients == null || $this.CountryCoefficients.indexOf(item) === -1) return;
                var _index = $this.CountryCoefficients.indexOf(item);
                $this.CountryCoefficients.splice(_index, 1);
item.EUProgramme = null;
}
static clearCountryCoefficients = ($this) => { $this.CountryCoefficients = null; }

static GetCCC($this: any, country: any,date: any,throwOnNotFound: any): any{if ((!((date != null)) && throwOnNotFound)) {throw Error("Provide a date in order to search for the CCC!");}else if ((!((date != null)))) {console.warn("Provide a date in order to search for the CCC!");return null;}
if ((country == null && throwOnNotFound)) {throw Error("Provide a Country in order to search for the CCC!");}else if ((country == null)) {console.warn("Provide a Country in order to search for the CCC!");return null;}
date = new Date(new Date(date)?.setHours(0, 0, 0, 0));
let cccs = $this?.CountryCoefficients?.linq?.where((a) => a?.Country == country && (new Date(new Date(new Date(a?.DateFrom)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(date).getTime()) && (new Date(new Date(new Date(a?.DateTo)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(date).getTime()))?.toArray();
if (CLMS.Framework.Number.GreaterThan(() => cccs.length, () => 1) && throwOnNotFound) {throw Error(CLMS.Framework.String.Format("Found multiple CCCs for programme: {0}, country: {1}, date: {2}", $this?.Name, country?.Name, CLMS.Framework.DateTime.ToString(date, "dd/MM/yyyy")));}else if (CLMS.Framework.Number.GreaterThan(() => cccs.length, () => 1)) {console.warn(CLMS.Framework.String.Format("Found multiple CCCs for programme: {0}, country: {1}, date: {2}", $this?.Name, country?.Name, CLMS.Framework.DateTime.ToString(date, "dd/MM/yyyy")));return null;}else if (CLMS.Framework.Number.LessThanOrEqual(() => cccs.length, () => 0)) {console.warn(CLMS.Framework.String.Format("Could not find CCC for programme: {0}, country: {1}, date: {2}", $this?.Name, country?.Name, CLMS.Framework.DateTime.ToString(date, "dd/MM/yyyy")));return null;}
return cccs?.linq?.where()?.firstOrDefault(null);
}
static GetUnitCostRate($this: any, date: any): any{if ((!((date != null)))) {throw Error("Provide a date in order to search for the Unit Cost Rate!");}
date = new Date(new Date(date)?.setHours(0, 0, 0, 0));
let rates = $this?.UnitCostRates?.linq?.where((a) => (new Date(new Date(new Date(a?.DateFrom)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(date).getTime()) && (new Date(new Date(new Date(a?.DateTo)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(date).getTime()))?.toArray();
if (CLMS.Framework.Number.GreaterThan(() => rates.length, () => 1)) {throw Error(CLMS.Framework.String.Format("Found multiple Unit Cost Rates for programme: {0}, date: {1}", $this?.Name, CLMS.Framework.DateTime.ToString(date, "dd/MM/yyyy")));}
return rates?.linq?.where()?.firstOrDefault(null);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Name == null || $this.Name == "";
            }


}